<template>
	<div class="display_wrapper">

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Tax Category</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_edit" v-if="displayData && !displayData.isSystem">
		    	<v-icon>edit</v-icon>
		    </v-btn>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn>
		</v-toolbar>

		<div class="display hasToolbar">
			<div class="display_title">{{displayData.name}}</div>

			<v-list class="section-container" two-line>
		        <v-subheader light>Details</v-subheader>
		        <v-divider></v-divider>
		        <div>
		        	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Tax (Percentage)</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.taxValue}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider v-if="displayData.isCessApplicable"></v-divider>
		        </div>
		       	<div v-if="displayData.isCessApplicable">
		       	 	<v-list-tile v-if="displayData.cessValue">
			          	<v-list-tile-content>
			          		<v-list-tile-title>Cess (Percentage)</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.cessValue}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>

					<v-divider v-if="displayData.cessValueOnQuantity"></v-divider>

					<v-list-tile v-if="displayData.cessValueOnQuantity">
			          	<v-list-tile-content>
			          		<v-list-tile-title>Cess (Value on Quantity)</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.cessValueOnQuantity}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
		       	</div>

		    </v-list>
		</div>

		<dialog-confirmation ref="ref_dialogDeleteConfirmation" header="Delete Master?" :actionMethod="fn_deleteMaster" params="delete" :displayView='true'></dialog-confirmation>
	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
import {masterMixin} from '../../master_mixin.js'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'

	export default{
		mixins: [masterMixin],
		data(){
			return{
				displayData:{}
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation
		},
		methods:{
			fn_get: function(itemId){
				var self = this;
				this.getData('TaxCategory', itemId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          self.displayData = JSON.parse(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},
			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Tax Cateogry";
				viewObject.TopMenu = [menuItem.edit];
				viewObject.isBottomMenu = true;

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';

				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_getBottomMenu: function (tagId) {
				var bottomMenu = {"BottomMenu": [menuItem.copy]};
				!this.displayData.isSystem ? bottomMenu.BottomMenu.push(menuItem.delete) : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.taxCategoryId){
					this.fn_edit();
				}
				else if(menuAction=='copy'){
					this.$router.push({path:'/tax/category/items/new', query:{tagId:this.guidWeb(), itemId:this.displayData.taxCategoryId, copy:true}});
				}
				else if(menuAction=='delete'){
					this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = true;
				}
			},

			fn_deleteMaster: function(){
				let self = this;
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				this.fn_deleteMasterItem('taxCategory', this.displayData.taxCategoryId, function(response){
					if(response){
                        self.showToast('Item deleted');
                        self.$router.go(-1);
                    }
                    else{
                        self.showToast("Item cannot be deleted as already in use");
                    }
				})
			},

			fn_edit: function () {
				this.$router.push("/tax/category/items/"+this.displayData.taxCategoryId+"/edit");
			}
		},
		mounted: function(){
			
			this.fn_showWebView();

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			
			if(this.$route.params && this.$route.params.tagId){
				this.fn_get(this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation){
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/tax_category/display.vue